import { Chip, Stack } from "@mui/material";

export default function FilterChips({ options, value, onChange }) {
  return (
    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
      {(options || []).map((opt) => {
        const active = opt.key === value;
        return (
          <Chip
            key={opt.key}
            label={opt.label}
            clickable
            color={active ? "primary" : "default"}
            variant={active ? "filled" : "outlined"}
            onClick={() => onChange?.(opt.key)}
            sx={{ borderRadius: 999 }}
          />
        );
      })}
    </Stack>
  );
}
